import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { GenderParams } from './service';

export enum GenderActions {
  Failure = '[Catalogs Gender] Failure',
  Request = '[Catalogs Gender] Request',
  Success = '[Catalogs Gender] Success',
}

export const GenderFailure = createAction(GenderActions.Failure, props<{ error: HttpErrorResponse }>());

export const GenderRequest = createAction(GenderActions.Request, props<{ parameters: GenderParams }>());

export const GenderSuccess = createAction(GenderActions.Success, props<{ data: ParameterResult }>());
